var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-tabs", {
    attrs: {
      animated: false
    },
    model: {
      value: _vm.activeKey,
      callback: function callback($$v) {
        _vm.activeKey = $$v;
      },
      expression: "activeKey"
    }
  }, [_c("a-tab-pane", {
    key: "1",
    attrs: {
      tab: _vm.$t("inquiryDetail.info2")
    }
  }, [_c("QuoteDetailInfo")], 1), _c("a-tab-pane", {
    key: "2",
    attrs: {
      tab: _vm.$t("inquiryDetail.product")
    }
  }, [_c("QuoteDetailProduct")], 1), _c("a-tab-pane", {
    key: "3",
    attrs: {
      tab: _vm.$t("inquiryList.notifyVersion")
    }
  }, [_c("quoteNotifyInfo")], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };